<template>
  <div id="patient-details" class="wrrapper mb-base">
    <page-heading title="Patient Details" back border>
      <template #content>
        <div class="mr flex align-center">
          <div
            @click="imagePopup()"
            class="flex align-center mr-2 preview-image cursor"
            v-if="attachments && attachments.length"
          >
            <a href="#" ref="element" class="image-popup">
              <div style="text-align: center; padding: 1rem;">
                <div v-for="attachment in attachments" :key="attachment.id">
                  <strong
                    style="
                      font-size: 1.2rem;
                      line-height: 1rem;
                      word-spacing: 0.03em;
                      font-weight: 400;
                      margin: 1.5rem;
                    "
                    >Posted At: {{ formatDate(attachment.created_at) }}</strong
                  >
                  <div class="image-container">
                    <img
                      :src="attachment.path"
                      :alt="attachment.name"
                      style="display: block; margin: auto; padding: 1rem; margin-top: 1rem; margin-bottom: 1rem; width: 50vw !important ;"
                      class="newtab-image"
                    />
                  </div>
                </div>
              </div>
            </a>
            <span class="mdi mdi-24px mdi-eye"></span>
            <p>Preview attachment{{ attachments.length > 1 ? "s" : "" }}</p>
          </div>
          <div class="flex align-center" v-if="!search">
            <span class="mr-number">FH:</span>
            <p>{{ detailsPatient.mr_no }}</p>
          </div>
          <div>
            <!-- <Select
              v-if="isAdmin && !detailsPatient.mr_no"
              class="mr-2"
              styles="expenses-select"
              :input="handleBranchChange"
              placeholder="Select Branch"
              :options="brachData"
            /> -->
          </div>
          <div class="patinet-reports flex align-center" v-if="search">
            <Input
              @enter="handleSearch"
              v-model="searchText"
              type="text"
              placeholder="MR No / Mobile No"
              icon="mdi-magnify"
              :handleSearch="handleSearch"
            />
          </div>
        </div>
      </template>
    </page-heading>
    <div>
      <div class="content">
        <div class="patient-summary-grid">
          <div class="patient-summary-item patient-summary-item--wide">
            <span>Full Name</span>
            <strong>{{ detailsPatient.name || "-" }}</strong>
          </div>
          <div class="patient-summary-item">
            <span>Father/Husband Name</span>
            <strong>{{ detailsPatient.fatherOrHusbandName || "-" }}</strong>
          </div>
          <div class="patient-summary-item">
            <span>Age</span>
            <strong>{{ detailsPatient.age || "-" }}</strong>
          </div>
          <div class="patient-summary-item patient-summary-item--wide">
            <span>Address</span>
            <strong>{{ detailsPatient.address || "-" }}</strong>
          </div>
          <div class="patient-summary-item">
            <span>Contact Number</span>
            <strong>{{ detailsPatient.contactNumber || "-" }}</strong>
          </div>
          <div class="patient-summary-item">
            <span>Gender</span>
            <strong>{{ userGender || "-" }}</strong>
          </div>
          <div class="patient-summary-item">
            <span>Referred By</span>
            <strong>{{ detailsPatient.referredBy || "-" }}</strong>
          </div>
        </div>
        <tabs>
          <tab name="History">
            <data-table
              class="mt-3"
              :cols="columns"
              :rows="history"
              height="300px"
              :loading="loading"
            >
              <template slot="action" slot-scope="actions">
                <dropdown-menu
                  v-if="actions && actions.actions.template !== null"
                  :handleItemClick="val => handleItems(val, actions)"
                  :items="[
                    ...(actions.actions.status == 3
                      ? ['Print']
                      : ['Processed']),
                    'View',
                    'Delete'
                  ]"
                />
                <!-- <span>{{ actions.actions }}</span> -->
                <span
                  v-else
                  className="button--primary"
                  @click="val => handleAddReport(actions)"
                  style="font-size: 20px; color: var(--accent-600); margin-left: 1.2rem; cursor: pointer; position: relative;"
                >
                  ✛
                  <div class="tooltip">Add Report</div>
                </span>
              </template>
            </data-table>
          </tab>
          <tab name="Reports">
            <!-- <Button
              title="Add new report"
              className="button--primary add-report"
              :onClick="addReport"
            /> -->
            <data-table
              class="mt-3"
              :cols="reports"
              :rows="reportsList"
              height="300px"
              :loading="loading"
            >
              <template slot="action" slot-scope="actions">
                <dropdown-menu
                  :handleItemClick="val => handleItems(val, actions)"
                  :items="[
                    ...(actions.actions.status == 3
                      ? ['Print']
                      : ['Processed']),
                    'View'
                  ]"
                />
              </template>
            </data-table>
          </tab>
        </tabs>
      </div>
      <!-- Report sidebar -->
      <transition name="sidebar-slide">
        <div v-if="sidebarOpen" class="report-sidebar-overlay">
          <div class="report-sidebar">
            <div class="report-sidebar__header">
              <div class="collapse flex align-center cursor" @click="toggle">
                <img
                  :class="[show ? 'rotate' : 'header-icon', 'mr-1']"
                  src="@/assets/chevron-down-icon.png"
                  alt="icon"
                />
                <Heading heading="Patient Details" />
              </div>
              <div class="flex align-center" style="gap: 10px;">
                <Button
                  :title="Object.keys(report).length === 0 ? 'Save' : 'Update'"
                  className="button--primary"
                  :loader="loading"
                  :onClick="saveDetails"
                />
                <button
                  class="report-sidebar__close"
                  @click="closeSidebar"
                  aria-label="Close"
                >
                  ✕
                </button>
              </div>
            </div>
            <div class="report-sidebar__body">
              <div class="details flex flex-wrap" v-if="!show">
                <Input
                  class="mb-base mr-2"
                  label="Full Name"
                  type="text"
                  v-model="detailsPatient.name"
                  disabled
                />
                <Input
                  class="mb-base mr-2"
                  label="Father/Husband Name"
                  type="text"
                  v-model="detailsPatient.fatherOrHusbandName"
                  disabled
                />
                <Input
                  class="mb-base mr-2"
                  label="Age"
                  type="text"
                  v-model="detailsPatient.age"
                  disabled
                />
                <Input
                  class="mb-base mr-2"
                  label="Address"
                  type="text"
                  v-model="detailsPatient.address"
                  disabled
                />
                <Input
                  class="mb-base mr-2"
                  label="Contact Number"
                  type="text"
                  v-model="detailsPatient.contactNumber"
                  disabled
                />
                <Radio
                  class="mb-base mr-2"
                  outerLabel="Gender"
                  type="radio"
                  name="custom"
                  v-model="userGender"
                  :options="gender"
                />
                <Select
                  class="mb-base mr-2"
                  label="Referred By"
                  styles="role-select"
                  :value="referredBy.name"
                  :input="handlerefferedBy"
                  :options="refferedByDoctors"
                  :loading="isLoadingRefferedBy"
                />
                <TextArea
                  label="Comment"
                  styles="comment mb-base mr-2"
                  name="comment"
                  placeholder="Write detail here"
                  v-model="comment"
                />
              </div>
              <div class="report">
                <div class="flex align-center space-between">
                  <Heading heading="Report" />
                  <div class="flex">
                    <Select
                      class="mr-2"
                      styles="expenses-select"
                      :input="branchChage"
                      :placeholder="branchPlaceHolder || 'Loading branches...'"
                      :options="brachData"
                      :loading="brachData.length === 0"
                    />
                    <Button
                      v-if="brachData.length === 0"
                      title="Refresh"
                      className="button--secondary"
                      :onClick="refreshBranchData"
                      style="margin-left: 10px; padding: 8px 12px;"
                    />
                    <Select
                      v-if="Object.keys(report).length === 0"
                      styles="template-select"
                      placeholder="Select Template"
                      :input="selectTemplate"
                      :options="templateList"
                    />
                  </div>
                </div>
                <div @click="handleTemplate">
                  <TemplateEditor
                    ref="patient"
                    :text="report"
                    :content="report"
                    :height="`${!show ? '300' : '500'}`"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import Heading from "@/components/Heading";
import Input from "@/components/Input";
import Radio from "@/components/Radio";
import { Tabs, Tab } from "vue-tabs-component";
import DataTable from "@/components/DataTable";
import Button from "@/components/Button";
import DropdownMenu from "@/components/DropdownMenu";
import TextArea from "@/components/TextArea.vue";
import { mapActions, mapGetters } from "vuex";
import {
  formatGender,
  downloadPdf,
  convertoHtml,
  formatDateTime
} from "@/utils/helpers";
import { getHeader, getFooter, createPdfContnets } from "@/utils/pdf";
import Select from "@/components/Select";
import TemplateEditor from "@/components/TemplateEditor";
import { permissionsMiddleWare } from "../../../utils/permissionsMiddleWare";

export default {
  props: {
    search: {
      type: Boolean,
      default: false
    }
  },
  components: {
    TemplateEditor,
    DropdownMenu,
    TextArea,
    Heading,
    Select,
    DataTable,
    Button,
    Input,
    Radio,
    Tabs,
    Tab
  },
  data() {
    return {
      show: false,
      sidebarOpen: false,
      templateId: "",
      report: {},
      currentHistoryId: null,
      historyId: "",
      refferedName: "",
      referredBy: {},
      isLoadingRefferedBy: false,
      brachData: [],
      currentBranch: null,
      isAdmin: false,
      searchText: "",
      payloadHistoryId: null,
      comment: "",
      patientDetailsBranch: null,
      attachments: null,
      paramId: null,
      gender: [
        { id: "male", for: "male", label: "Male" },
        { id: "female", for: "female", label: "Female" }
      ],
      columns: [
        { column: "serial", label: "#", width: "60" },
        { column: "service", label: "Service Availed", sortable: true },
        { column: "prepared_by", label: "Created By", sortable: true },
        { column: "created_at", label: "Date", sortable: true },
        { column: "status", label: "Status", sortable: true },
        { column: "branch", label: "Branch Name", sortable: true },
        { column: "action", label: "Action" }
      ],
      reports: [
        { column: "serial", label: "#", width: "60" },
        { column: "name", label: "Name", sortable: true },
        { column: "prepared_by", label: "Prepared By", sortable: true },
        { column: "updated_at", label: "Date", sortable: true },
        { column: "status", label: "Status", sortable: true },
        { column: "action", label: "Action" }
      ]
    };
  },
  methods: {
    ...mapActions({
      patientDetails: "receptionist/patientDetails",
      updateDetails: "receptionist/updateDetails",
      listHistory: "receptionist/listHistory",
      lookupView: "doctors/lookupView",
      templateReportsList: "reports/templateReportsList",
      addHistory: "reports/addHistory",
      updateHistory: "reports/updateHistory",
      createPdf: "reports/createPdf",
      setHistoryStatus: "reports/setHistoryStatus",
      settingsList: "bussiness/settingsList",
      resetReceptionist: "receptionist/resetReceptionist",
      searchHistory: "receptionist/searchHistory",
      cancelAppointment: "receptionist/cancelAppointment",
      listRefferedByDoctors: "doctors/listRefferedByDoctors"
    }),
    ...mapActions("expenses", ["fetchBranch"]),
    formatDate(date) {
      return formatDateTime(date);
    },
    handleBranchChange(val) {
      if (val && val != null) {
        this.patientDetailsBranch = val.key;
      }
    },
    branchChage(val) {
      if (val && val != null) {
        this.patientDetailsBranch = val.key;
      }
      if (val === null) {
        this.patientDetailsBranch = null;
      }
    },
    handlerefferedBy(val) {
      if (val) {
        this.referredBy = val;
        this.refferedName = val.name;
      } else {
        this.referredBy = {};
        this.refferedName = "";
      }
    },
    syncReferredBy(referredByName) {
      this.refferedName = referredByName || "";
      const matched = (this.refferedByDoctors || []).find(
        item => item.name === referredByName
      );
      this.referredBy =
        matched || (referredByName ? { name: referredByName } : {});
    },
    handleAddReport(item) {
      this.addReport();
      this.payloadHistoryId = item.actions.id;
    },
    handleSearch() {
      if (permissionsMiddleWare("History By Mr")) {
        if (this.searchText && this.patientDetailsBranch !== null) {
          const params = {};
          params.searchText = this.searchText;
          params.branchId = this.patientDetailsBranch;
          this.searchHistory(params).then(() => {
            this.patientDetails(this.patientId).then(() => {
              if (permissionsMiddleWare("View History")) {
                this.listHistory(this.detailsPatient.id);
              } else {
                this.$toasted
                  .info(
                    "This action cannot be performed by you due to insufficient authorization. Action: View History"
                  )
                  .goAway("3000");
              }
              if (this.detailsPatient.lookupId) {
                this.lookupView(this.detailsPatient.lookupId);
              }
            });
          });
        } else if (!this.searchText) {
          this.$toasted.show("Add mr-no to search").goAway("3000");
        } else if (this.patientDetailsBranch === null) {
          this.$toasted.show("Please select branch").goAway("3000");
        }
      } else {
        this.$toasted
          .info(
            "This action cannot be performed by you due to insufficient authorization. Action : History By Mr"
          )
          .goAway("3000");
      }
    },
    imagePopup() {
      const element = this.$refs.element;
      var newTab = window.open();
      setTimeout(function() {
        newTab.document.body.innerHTML = element.innerHTML;
      }, 500);
      return false;
    },
    toggle() {
      this.show = !this.show;
    },
    handleTemplate() {
      this.show = true;
    },
    handleItems(val, actions) {
      if (val == "Print") {
        downloadPdf(actions && actions.actions && actions.actions.attachment);
      } else if (val == "Processed") {
        const settings =
          this.settings && this.settings.length > 0
            ? this.settings.find(item => item)
            : {};
        const headerData = {
          description:
            this.detailsPatient.referredBy == this.lookupDetails.name
              ? this.lookupDetails.description
              : "",
          performed_on: actions && actions.actions.performed_on
        };
        if (
          this.detailsPatient.referredByDescription &&
          this.detailsPatient.referredByDescription !== null
        ) {
          this.detailsPatient.referredBy = `${this.detailsPatient.referredBy} : ${this.detailsPatient.referredByDescription}`;
        }

        const html = {
          html: createPdfContnets(
            getHeader(this.detailsPatient, headerData),
            convertoHtml(actions.actions.report),
            getFooter(settings),
            headerData.description
          ),
          historyId: actions.actions.id
        };

        const user = {
          contactNumber: this?.detailsPatient?.contactNumber,
          name: actions?.actions?.name,
          patient: this?.detailsPatient?.name,
          fatherName: this?.detailsPatient?.fatherOrHusbandName,
          cellNo: this?.detailsPatient.lookup?.cell_no,
          id: actions?.actions?.id,
          patientId: this?.detailsPatient?.id
        };

        const sendToDoctor = this.validateSessionStatus?.messageSettings
          ?.sendToDoctor;

        this.createPdf({
          payload: html,
          report: user,
          vm: this,
          sendToDoctor: sendToDoctor
        });
      } else if (val == "View") {
        this.report = (actions.actions && actions.actions.report) || {};
        this.historyId = actions.actions.id;
        this.sidebarOpen = true;
        this.comment = actions.actions.comment;
        // this.$modal.show("reportView");
        this.patientDetailsBranch = this.user.userBranchId;
      } else if (val == "Delete") {
        const status = {
          status: 0
        };
        this.setHistoryStatus({
          id: actions.actions.id,
          payload: status
        }).then(() => {
          this.listHistory(this.currentHistoryId);
        });
      }
    },
    closeSidebar() {
      this.sidebarOpen = false;
      this.report = {};
      this.comment = "";
      this.show = false;
    },
    addReport() {
      this.sidebarOpen = true;
      this.patientDetailsBranch = this.user.userBranchId;
    },
    selectTemplate(val) {
      const report = val && typeof val.report == "object" ? val.report : {};
      this.$refs.patient.editor.setContents(report, "api");
      this.templateId = val.id;
    },
    updateUserId() {
      const parentIds = this.history
        .filter(item => item.parentId !== null)
        .map(item => item.parentId);

      const userId = this.history
        .filter(item => item?.parentId !== null)
        .map(item => item?.userId)
        .find(userId => userId !== undefined);

      this.history.forEach(item => {
        if (this.history?.length > 1 && item?.chargeId !== null) {
          if (item.userId === null) {
            if (parentIds.includes(item.id)) {
              const payload = {
                status: 1,
                userId: userId,
                historyId: item.id
              };
              this.cancelAppointment({ id: item.id, payload });
            }
          }
        }
      });
    },
    updateUserIdFirst() {
      const userId = this.user.id;
      this.detailsPatient.histories?.filter(item => {
        if (item.chargeId !== null) {
          if (item.userId === null) {
            const payload = {
              status: 1,
              userId: userId,
              historyId: item.id
            };
            if (item.status == 4 || item.status == 7) {
              delete payload.status;
            }
            this.cancelAppointment({ id: item.id, payload });
          }
        }
      });
    },
    async refreshBranchData() {
      try {
        await this.fetchBranch();
        if (this.fetchUserBranch && this.fetchUserBranch.length > 0) {
          this.brachData = this.fetchUserBranch.map(elem => ({
            name: elem.name,
            key: elem.id
          }));
          console.log("Branch data refreshed:", this.brachData);
        }
      } catch (error) {
        console.error("Error refreshing branch data:", error);
      }
    },
    saveDetails() {
      const id =
        this?.$route?.params?.id == undefined
          ? this?.detailsPatient?.id
          : this?.$route?.params?.id;
      this.paramId = this?.detailsPatient?.id;
      const user = {
        referredBy: this.referredBy.name || this.refferedName,
        ...(this.referredBy.id ? { lookupId: this.referredBy.id } : {})
      };
      const currentPatientId = this.payloadHistoryId;
      this.updateDetails({ id, user, currentPatientId }).then(() => {
        this.patientDetails(id);
      });
      const payload = {
        patientId: id,
        templateId: this.templateId,
        report: this?.$refs?.patient?.editor?.getContents(),
        comment: this.comment,
        branchId: this.patientDetailsBranch,
        parentId: this.payloadHistoryId
      };
      if (this.patientDetailsBranch !== null) {
        if (Object.keys(this.report).length === 0) {
          if (permissionsMiddleWare("Create History")) {
            this.addHistory(payload).then(() => {
              this.listHistory(id);
              this.patientDetailsBranch = null;
              this.comment = "";
              this.$toasted
                .success("Patient details saved successfully")
                .goAway("3000");
              this.sidebarOpen = false;
            });
          } else {
            this.$toasted
              .info(
                "This action cannot be performed by you due to insufficient authorization. Action: Create History"
              )
              .goAway("3000");
          }
        } else {
          this.updateHistory({
            id: this.historyId,
            payload
          }).then(() => {
            this.listHistory(id);
            this.patientDetailsBranch = null;
            this.report = {};
            this.comment = "";
            this.$toasted.success("Report updated successfully").goAway("3000");
            this.sidebarOpen = false;
          });
        }
      } else {
        this.$toasted
          .error("Please select branch before saving patient details")
          .goAway("3000");
      }
    }
  },
  computed: {
    ...mapGetters({
      detailsPatient: "receptionist/detailsPatient",
      getAttachments: "receptionist/getAttachments",
      getHistory: "receptionist/getHistory",
      reportsTemplate: "reports/reportsTemplate",
      lookupDetails: "doctors/lookupDetails",
      settings: "bussiness/settings",
      historySearchResults: "receptionist/historySearchResults",
      loading: "loading",
      user: "auth/userInfo",
      fetchUserBranch: "expenses/fetchUserBranch",
      validateSessionStatus: "auth/validateSessionStatus",
      refferedByDoctors: "doctors/refferedByDoctors"
    }),
    branchPlaceHolder() {
      return this.brachData?.find(e => e.key === this.patientDetailsBranch)
        ?.name;
    },
    patientId() {
      const searchResults = this.historySearchResults || [];
      let [item] = [...searchResults];
      return item.patientId;
    },
    history() {
      const data = this.getHistory || [];
      const filterData = data.map(item => ({
        ...item,
        status:
          item.chargeId === null
            ? item.status
            : item.status === 1
            ? 3
            : item.status,
        service: item.charge
          ? item?.charge?.service?.name
          : item?.template?.name,
        doctor: item?.user?.employ?.full_name,
        created_at: item?.created_at,
        attachment: item?.attachment?.path,
        prepared_by: item?.createdBy?.employ?.full_name,
        name: item?.template?.name,
        updated_at: item.updated_at,
        // performed_on: item?.patient?.performed_on || item.patient?.created_at,
        branch: item?.branch?.name
      }));
      return filterData;
    },
    reportsList() {
      const data =
        (this.getHistory &&
          this.getHistory.filter(item => item.template !== null)) ||
        [];
      const filterData = data.map(item => ({
        ...item,
        name: item.template && item.template.name,
        prepared_by:
          item.user && item.user.employ && item.user.employ.full_name,
        updated_at: item && item.updated_at,
        performed_on:
          (item && item.patient && item.patient.performed_on) ||
          item.patient.created_at,
        historyId: item.id,
        attachment: item.attachment && item.attachment.path
      }));
      return filterData;
    },
    userGender() {
      return formatGender(this.detailsPatient && this.detailsPatient.gender);
    },
    templateList() {
      const template = this.reportsTemplate || [];
      return template.map(item => ({
        id: item.id,
        name: item.name,
        report: item.report
      }));
    }
    // attachments() {
    //   return this?.detailsPatient?.attachment || [];
    // },
  },
  watch: {
    detailsPatient(val) {
      this.syncReferredBy(val?.referredBy);
    },
    refferedByDoctors() {
      this.syncReferredBy(this.detailsPatient?.referredBy);
    },
    brachData(newData) {
      console.log("Branch data changed:", newData);
    }
  },
  beforeDestroy() {
    this.resetReceptionist();
  },
  async mounted() {
    this.currentHistoryId =
      this?.$route?.params?.id == undefined
        ? this.paramId
        : this?.$route?.params?.id;
    if (this.currentHistoryId) {
      if (permissionsMiddleWare("View History")) {
        await this.listHistory(this.currentHistoryId);
      } else {
        this.$toasted
          .info(
            "This action cannot be performed by you due to insufficient authorization. Action : View History"
          )
          .goAway("3000");
      }
      this.updateUserIdFirst();
      this.attachments = this.getAttachments;
    }
    await this.updateUserId();
    this.patientDetailsBranch = this.user?.userBranchId;

    // Fetch branch data from API and populate brachData
    try {
      await this.fetchBranch();
      console.log("Fetched branch data:", this.fetchUserBranch);

      if (this.fetchUserBranch && this.fetchUserBranch.length > 0) {
        this.brachData = this.fetchUserBranch.map(elem => ({
          name: elem.name,
          key: elem.id
        }));
        console.log("Branch data populated from API:", this.brachData);
      } else {
        // Fallback to localStorage if API data is not available
        const storedBranchData =
          JSON.parse(localStorage.getItem("branchData")) || [];
        this.brachData = storedBranchData;
        console.log("Branch data loaded from localStorage:", this.brachData);
      }
    } catch (error) {
      console.error("Error fetching branch data:", error);
      // Fallback to localStorage on error
      const storedBranchData =
        JSON.parse(localStorage.getItem("branchData")) || [];
      this.brachData = storedBranchData;
    }

    // Additional fallback: if still no data, try to load from App.vue storeBranchData
    if (!this.brachData || this.brachData.length === 0) {
      console.log(
        "No branch data found, attempting to load from App.vue method"
      );
      // This will trigger the storeBranchData method from App.vue
      this.$root.storeBranchData();
      // Wait a bit and try again
      setTimeout(() => {
        const storedBranchData =
          JSON.parse(localStorage.getItem("branchData")) || [];
        this.brachData = storedBranchData;
        console.log(
          "Branch data loaded after App.vue fallback:",
          this.brachData
        );
      }, 1000);
    }

    this.templateReportsList();
    this.settingsList();
    this.isLoadingRefferedBy = true;
    Promise.all([
      this.listRefferedByDoctors("doctor"),
      this.listRefferedByDoctors("hospital")
    ])
      .then(() => (this.isLoadingRefferedBy = false))
      .catch(() => (this.isLoadingRefferedBy = false));
  }
};
</script>

<style>
#patient-details .content {
  padding: 18px 24px 24px;
}

#patient-details .details > div {
  flex: 0 0 30%;
  max-width: 30%;
}

.patient-summary-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px 18px;
  margin-bottom: 20px;
}

.patient-summary-item {
  min-width: 0;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--line);
}

.patient-summary-item--wide {
  grid-column: span 2;
}

.patient-summary-item span {
  display: block;
  margin-bottom: 5px;
  color: var(--muted-soft);
  font-size: var(--fs-eyebrow);
  font-weight: 700;
  letter-spacing: var(--tracking-eyebrow);
  line-height: 1.2;
  text-transform: uppercase;
}

.patient-summary-item strong {
  display: block;
  min-height: 20px;
  color: var(--ink-900);
  font-size: var(--fs-body);
  font-weight: 600;
  line-height: 1.45;
  overflow-wrap: anywhere;
}

.content .tabs-component-tabs {
  display: flex;
  align-items: center;
  gap: 28px;
  margin: 4px 0 0;
  border-bottom: 1px solid var(--line);
  list-style: none;
  padding: 0;
}

.content .tabs-component-tabs .is-active {
  border-bottom: 3px solid var(--accent-600);
}

.content .tabs-component-tab .tabs-component-tab-a {
  display: inline-flex;
  align-items: center;
  min-height: 42px;
  list-style: none;
  color: var(--muted);
  font-size: var(--fs-body);
  font-weight: 700;
  letter-spacing: 0;
  line-height: 1.3;
}

.content .tabs-component-tab.is-active .tabs-component-tab-a {
  color: var(--ink-900);
}

.add-report {
  float: right;
  margin-top: -80px;
}

.mr-number {
  font-weight: 600;
  margin-right: 4px;
  font-size: var(--fs-h2);
  line-height: 25px;
  letter-spacing: 0.04em;
  text-transform: capitalize;
  color: var(--ink-900);
}

.template-select {
  width: 300px;
}

.rotate {
  transform: rotate(-90deg);
  transition-duration: 0.3s;
}

.collapse .header-icon {
  transform: rotate(-0deg);
  transition-duration: 0.3s;
}

.preview-image p {
  font-size: var(--fs-sm);
  line-height: 16px;
  letter-spacing: 0.05em;
  text-transform: capitalize;
  color: var(--accent-600);
}

.preview-image span {
  margin-right: 10px;
  color: var(--accent-600);
}

.preview-image span:before {
  font-size: 1.5rem !important;
}

.content .textarea {
  margin-top: 0;
}

.image-popup {
  display: none;
}

.tooltip {
  background-color: var(--surface);
  color: var(--text);
  border: 1px solid var(--line);
  text-align: center;
  border-radius: var(--radius-sm);
  padding: 5px;
  position: absolute;
  z-index: 10000;
  bottom: 5%;
  right: -330%;
  transform: translateX(-50%);
  opacity: 0;
  font-size: var(--fs-sm);
  width: 10rem;
  box-shadow: var(--shadow-md);
  transition: opacity var(--dur) var(--ease);
}

.tooltip::after {
  content: "";
  position: absolute;
  top: 35%;
  left: 105%;
  rotate: -90deg;
  margin-left: -9px;
  border-width: 5px;
  border-style: solid;
  border-color: var(--line) transparent transparent transparent;
}

span:hover .tooltip {
  visibility: visible;
  opacity: 1;
}

/* Report Sidebar */
.report-sidebar-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 9000;
  display: flex;
  justify-content: flex-end;
}

.report-sidebar {
  width: 80%;
  height: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;
  box-shadow: -4px 0 24px rgba(0, 0, 0, 0.15);
  overflow: hidden;
}

.report-sidebar__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  border-bottom: 1px solid var(--line);
  flex-shrink: 0;
  background: #fff;
}

.report-sidebar__close {
  background: none;
  border: none;
  font-size: 18px;
  color: var(--muted);
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  line-height: 1;
}

.report-sidebar__close:hover {
  background: var(--color-surface-soft, #f9f0ff);
  color: var(--ink-900);
}

.report-sidebar__body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 24px;
  display: flex;
  flex-direction: column;
}

.report-sidebar__body .report {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.report-sidebar__body .report .template-editor {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.report-sidebar__body .report #editor {
  flex: 1;
  min-height: 300px;
  height: auto !important;
}

.report-sidebar__body .report .ql-container {
  flex: 1;
  min-height: 0;
  height: auto !important;
}

.report-sidebar__body .report .ql-editor {
  min-height: 300px;
}

/* Slide transition */
.sidebar-slide-enter-active,
.sidebar-slide-leave-active {
  transition: opacity 0.25s ease;
}

.sidebar-slide-enter-active .report-sidebar,
.sidebar-slide-leave-active .report-sidebar {
  transition: transform 0.25s ease;
}

.sidebar-slide-enter .report-sidebar,
.sidebar-slide-leave-to .report-sidebar {
  transform: translateX(100%);
}

.sidebar-slide-enter,
.sidebar-slide-leave-to {
  opacity: 0;
}

@media screen and (max-width: 980px) {
  .patient-summary-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media screen and (max-width: 640px) {
  #patient-details .content {
    padding: 16px;
  }

  .patient-summary-grid {
    grid-template-columns: 1fr;
  }

  .patient-summary-item--wide {
    grid-column: auto;
  }
}
</style>
